<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :vislble-alert="true"
      field-name="발생 사업장"
    />

    <!-- 점검 정보 >> 재해개요 -->
    <div>
      <h5 class="my-4"><i class="dot"></i> 재해 개요</h5>
      <div class="writeGridContainer">
        <div>
          <div class="form-title">구분</div>
          <p v-if="isPrint" class="print-input">{{ form.구분 }}</p>
          <div v-else class="w-full flex-1 flex gap-x-8 gap-y-4">
            <vs-radio v-model="form.구분" :disabled="board.readonly" vs-name="inputA_1" vs-value="직영">직영</vs-radio>
            <vs-radio v-model="form.구분" :disabled="board.readonly" vs-name="inputA_1" vs-value="사내수급">사내수급</vs-radio>
            <vs-radio v-model="form.구분" :disabled="board.readonly" vs-name="inputA_1" vs-value="사외수급">사외수급</vs-radio>
          </div>
        </div>
        <div>
          <div class="form-title">부서명/업체명</div>
          <p v-if="isPrint" class=" print-input">{{ form.companyName }}</p>
          <virtual-company-selector
            v-else-if="form.구분 === '직영'"
            :readonly="board.readonly"
            v-model="form.부서명_업체명"
            :company-name="form.companyName"
            class="w-full"
            :field-id="form.stdInfo.field_id"
            @select="targetCompany"
          />
          <company-selector
            v-else
            :readonly="board.readonly || !form.구분"
            v-model="form.부서명_업체명"
            :company-name="form.companyName"
            class="w-full"
            :field-id="form.stdInfo.field_id"
            @select="targetCompany"
          />
        </div>
        <div>
          <div class="form-title">재해형태</div>
          <p v-if="isPrint" class="print-input">{{ form.재해형태 }}</p>
          <disaster-class-selector
            v-else
            class="w-full"
            :readonly="board.readonly"
            v-model="form.재해형태"
          />
        </div>

        <div>
          <div class="form-title">발생일</div>
          <p v-if="isPrint" class="print-input">{{ form.발생일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.발생일" />
        </div>
        <div>
          <div class="form-title">자체점검 요청기한</div>
          <p v-if="isPrint" class="print-input">{{ form.자체점검요청기한 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.자체점검요청기한" />
        </div>
        <div>
          <div class="form-title">자체개선 요청기한</div>
          <p v-if="isPrint" class="print-input">{{ form.자체개선요청기한 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.자체개선요청기한" />
        </div>
      </div>
    </div>

    <div>
      <h5 class="my-4"><i class="dot"></i> 개선조치 및 보고</h5>
      <div class="writeGridContainer">
        <div>
          <div class="form-title">발생 사업장 개선조치</div>
          <p v-if="isPrint" class="print-input">{{ form.발생사업장개선조치 }}</p>
          <vs-select v-model="form.발생사업장개선조치" autocomplete v-else :readonly="board.readonly">
            <vs-select-item text="미완료" value="미완료" />
            <vs-select-item text="완료" value="완료" />
          </vs-select>
        </div>
        <div>
          <div class="form-title">경영책임자 보고</div>
          <p v-if="isPrint" class="print-input">{{ form.경영책임자_보고 }}</p>
          <vs-select v-model="form.경영책임자_보고" autocomplete v-else :readonly="board.readonly">
            <vs-select-item text="미완료" value="미완료" />
            <vs-select-item text="완료" value="완료" />
          </vs-select>
        </div>
        <div>
          <div class="form-title">보고일</div>
          <p v-if="isPrint" class="print-input">{{ form.보고일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.보고일" />
        </div>
      </div>
    </div>


    <table-custom
      :board="board"
      :is-print="isPrint"
      :controls="false"
      :multiple="false"
      :tableData="[
        { id: 'fieldName', title: '사업장명', type: 'text', readonly: true, },
        // { id: 'take', title: '개선조치 여부', type: 'select', selectData: ['비대상', '미완료', '완료'] },
        { id: 'takeDate', title: '조치일', type: 'date', placeholder: '', },
        { id: 'progress', title: '진행상태', type: 'customType'},
        { id: 'etc', title: '비고', type: 'text', placeholder: '', max: 200 },
      ]"
      v-model="form.개선조치현황"
      class="mt-28px"
    >
      <template #customType="{ row, index }">
        <custom-option-selector
          v-model="form.개선조치현황[index].progress"
          :options="['비대상', '1차제출', '최종제출', '적용대상 없음', '특이사항 없음', '직접입력']"
          :readonly="board.readonly"
          :addableOption="true"
          class="w-full"
        />
      </template>
    </table-custom>
    <!-- 파일첨부 -->
    <file-upload-module title="재발방지 대책" id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import TableCustom from "@/components/TableCustom.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import VirtualCompanySelector from "@/components/selector/VirtualCompanySelector.vue";

export default {
  components: {
    VirtualCompanySelector,
    CustomOptionSelector,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
    TableCustom,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    SignField,
    TableInspectMerge,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    targetCompany (value) {
      this.form.companyName = value.com_name
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        구분: "",
        부서명_업체명: "",
        companyName: "",
        재해형태: "",
        발생일: "",
        자체점검요청기한: "",
        자체개선요청기한: "",
        발생사업장개선조치: "",
        경영책임자_보고: "",
        보고일: "",
        개선조치현황: [
          { "id": 1, "fieldName": "인천공장", "take": "", "takeDate": "", "progress": "", "etc": "" },
          { "id": 2, "fieldName": "포항공장", "take": "", "takeDate": "", "progress": "", "etc": "" },
          { "id": 3, "fieldName": "당진공장", "take": "", "takeDate": "", "progress": "", "etc": "" },
          { "id": 4, "fieldName": "중앙기술연구소", "take": "", "takeDate": "", "progress": "", "etc": "" },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  word-break: keep-all;
}
</style>

